<style scoped lang="scss" type="text/scss">

</style>

<template>
    <div class="global-relative">
        <loading-placeholder :loading="requesting"></loading-placeholder>

        <el-table :data="contestantApplications" stripe border size="small" style="width: 100%">
            <el-table-column type="index" :index="indexMethod" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="competition_name" label="赛事名称" align="center" min-width="180"></el-table-column>
            <el-table-column prop="school_name" label="学校名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="team_name" label="队伍名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="personal_name" label="申请人姓名" align="center" min-width="100"></el-table-column>
            <el-table-column prop="extra_message" label="备注" align="center" min-width="90"></el-table-column>
            <el-table-column prop="status_text" label="申请状态" align="center" min-width="80">
                <template slot-scope="scope">
                    <status-tag :success="scope.row.is_approved === true"
                                positive-text="已批准"
                                negative-text="已驳回"
                    >
                    </status-tag>
                </template>
            </el-table-column>
            <el-table-column prop="update_time_text" label="更新时间" align="center" width="140"></el-table-column>
        </el-table>

        <pagination :page-size="pageSize" :current-page.sync="currentPage" :total="total"
                    @current-change="loadPlayerFinishedContestantApplications">
        </pagination>
    </div>
</template>

<script>
    import {handleContestantApplications} from '../../../../../utils/data-handler';
    import StatusTag from '../../../../../components/status-tag/index';
    import {indexMethod, updatePageOption} from '../../../../../utils/page';

    export default {
        name: '',
        components: {
            StatusTag
        },
        data () {
            return {
                contestantApplications: [],
                requesting: false,
                pageSize: 10,
                total: 0,
                currentPage: 1
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            },
            page () {
                return {
                    page_size: this.pageSize,
                    page_num: this.currentPage
                };
            }
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.loadPlayerFinishedContestantApplications();
                }
            }
        },
        methods: {
            indexMethod (index) {
                return indexMethod(index, this);
            },
            loadPlayerFinishedContestantApplications () {
                this.$normalRequest('player/loadPlayerFinishedContestantApplications', {
                    id: this.currentManagedPlayerId,
                    ...this.page
                }, false, false, this, 'requesting').then(data => {
                    updatePageOption(this, data);
                    this.contestantApplications = handleContestantApplications(data.list);
                });
            }
        }
    };
</script>
